import React, { useState, useEffect } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarConfig from "../../../components/SidebarConfig";
import { getCountryUser } from '../../../redux/countryUser/actions';
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";

//redux
import {
  getDepartamentUser,
  deleteDepartamentUser,
  editDepartamentUser,
  saveDepartamentUser,
  getDepartamentsUser
} from "../../../redux/departamentUser/actions";

const DepartmentMaintenance = (props) => {
  const schema = Yup.object().shape({
    nombre: Yup.string().ensure().required("**Campo requerido"),
    codigo: Yup.number().required("**Campo requerido"),
  });

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);

  //
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const [nombre, setNombre] = useState("");
  const [codigo, setCodigo] = useState("");
  const [_pais, setPais] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "departamento",
    desc: "Departamento",
  });

  //
  const dispatch = useDispatch();
  const {
    loaderDepartamentUser,
    departamentUser,
    departamentUserFail,
    saveLoaderDepartamentUser,
    departamentUserFormError,
  } = useSelector((store) => store.departamentUser);
 
  // Pais
  const { loaderCountryUser } = useSelector((store) => store.countryUser);
  
  const [selectedPais, setselectedPais] = useState([]);
  const [IsCountrySelect, setIsCountrySelect] = useState(false);

  const pages = Math.ceil(departamentUser ? departamentUser.count / limit : 0);

  //   Datos de CustomTable
  const columns = [
    {
      Header: "Código",
      accessor: "codigo",
    },
    {
      Header: "Departamento",
      accessor: "nombre",
    },

    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="d-flex button-group " role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];
  const filters = [
    { id: "nombre", desc: "Departamento" },
    { id: "codigo", desc: "Código" },
  ];

  const _getDepartamentUser = (
    offs = offset,
    lim = limit,
    code = codigo,
    ndepto = nombre,
    filter = _pais,
    // tipo_Busqueda = tipoBusqueda
  ) =>{
    console.log(_pais)
    dispatch(
      getDepartamentUser({
        offset: offs,
        limit: lim,
        codigo: code,
        nombre: ndepto,
        filter:filter,
        tipo_busqueda:"pais_id"
        // tipo_busqueda: tipo_Busqueda,

        //   filter:

        //     tipoBusqueda.id === "fecha_creacion"
        //       ? filt !== ""
        //         ? !isNaN(filt)
        //           ? filt
        //           : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
        //               8
        //             )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
        //               4
        //             )}-${filt.charAt(0)}${filt.charAt(1)}`
        //         : filt
        //       : filt,
      })
    );
  }
  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteDepartamentUser(id, data));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getDepartamentUser(oOffset, limit, oSearch);
  };

  const onAdd = () => {
    if (_pais !== "") {
      setIsCountrySelect(true);
      
    } else {
      setIsCountrySelect(false);
    }
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getDepartamentUser(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    if (!edit) {
      dispatch(saveDepartamentUser(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      dispatch(editDepartamentUser(req, index, setShowFormModal));
    }
  };

  useEffect(() => {
    dispatch(getCountryUser( ));
    _getDepartamentUser()
  }, [dispatch])

  const countries = useSelector(store => store.countryUser.countryUser);
  


  return (
    <>
      <CustomNavbar onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">Departamentos</h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <div className="d-flex justify-content-start">
            <Form.Group as={Col} md={4} className="mb-md-1">
              <Row>
                <Form.Label column sm={3}>
                  País
                </Form.Label>
                <Col sm={9}>
                  <Row className="d-flex flex-wrap justify-content-start align-items-center">
                    <Col sm={loaderCountryUser ? "10" : "12"}>
                      <Form.Control
                        as="select"
                        id="pais"
                        name="pais"
                        className="col rounded-pill"
                        defaultValue=""
                        disabled={loaderCountryUser}
                        onChange={(e) => {
                          e.preventDefault();
                          setPais(e.currentTarget.value);
                          
                          _getDepartamentUser(
                            offset,
                            limit,
                            codigo,
                            nombre,
                            e.currentTarget.value,
                           
                          );
                        }}
                      >
                        <option
                          className="text-muted"
                          value=""
                          selected
                          disabled
                        >
                          Selecionar País
                        </option>
                        {!!countries && !!countries.data && countries.data.length > 0 &&
                          countries.data.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.nombre}
                            </option>
                          ))}
                      </Form.Control>
                    </Col>
                    {loaderCountryUser ? (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    ) : null}
                  </Row>
                </Col>
              </Row>
            </Form.Group>
          </div>
          <div className="d-flex justify-content-around"></div>
          {!!departamentUserFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {departamentUserFail}
            </Alert>
          )}
          {!!departamentUserFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {departamentUserFail}
            </Alert>
          )}
          {loaderDepartamentUser ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : departamentUser && departamentUser.count > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={departamentUser.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={departamentUser.count}
                pages={pages}
                pagFunc={_getDepartamentUser}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay Departamentos, comience creando algunos.
            </Alert>
          )}
        </Container>
         {/*Modal*/}
         <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              pais: edit ? editItem.pais : _pais,
              codigo: edit ? editItem.codigo : "",
              nombre: edit ? editItem.nombre : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              //setFieldValue,
              values,
              touched,
              //isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit ? "Editar Departamento" : "Crear Departamento"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {departamentUserFormError &&
                  typeof departamentUserFormError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {departamentUserFormError}
                    </Alert>
                  ) : null}
                  <Form.Group as={Col} className="mb-1  ">
                    <Form.Label column sm="12" md="12">
                      País
                    </Form.Label>
                   
                      <Row className="d-flex flex-wrap justify-content-start align-items-center">
                        <Col
                          sm={loaderCountryUser  ? "12" : "12"}
                        >
                          <Form.Control
                            as="select"
                            id="pais"
                            name="pais"
                            disabled
                            className="col rounded-pill"
                            isInvalid={touched.pais && errors.pais}
                            isValid={touched.pais && !errors.pais}
                            onBlur={handleBlur("pais")}
                            value={values.pais}
                            // defaultValue={empresa}
                           
                            onChange={(e) => {
                            //   dispatch(
                            //     getPeriodicityByOrg({
                            //       tipo_busqueda: "empresa__id",
                            //       filter: parseInt(e.currentTarget.value),
                            //     //   tipo_busqueda_2: "anio",
                            //     //   filter_2: parseInt(n),
                            //     })
                            //   );
                            // dispatch(
                            //   getPeriodicityByOrg({
                            //     tipo_busqueda: "empresa__id",
                            //     filter: parseInt(e.currentTarget.value),
                            //   })
                            // );
                              if (e.currentTarget.value !== "") {
                                setIsCountrySelect(true);
                              } else {
                                setIsCountrySelect(false);
                              }
                              handleChange(e);
                            }}
                          >
                            <option
                              className="text-muted"
                              value=""
                              selected
                              disabled
                            >
                              Seleccionar Pais
                            </option>
                            {countries.data.length > 0 &&
                              countries.data.map((item) => 
                                <option key={item.id} value={item.id} selected>
                                    {item.nombre}
                                  </option>
                              )}
                          </Form.Control>
                        </Col>
                        {loaderCountryUser  ? (
                          <Col sm={1}>
                            <Spinner animation="border" size="sm" />
                          </Col>
                        ) : null}
                      </Row>
                      {touched.pais && errors.pais && (
                        <Col>
                          <small className="text-danger">
                            {errors.pais}
                          </small>
                        </Col>
                      )}
                    
                  </Form.Group>

                  <Form.Group as={Col} className="mb-1  ">
                    <Form.Label column sm="12" md="12">
                      Código
                    </Form.Label>

                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loaderDepartamentUser ? "12" : "12"}>
                        <Form.Control
                          name="codigo"
                          className="rounded-pill"
                          required
                          type="number"
                          value={values.codigo}
                          onBlur={handleBlur("codigo")}
                          onChange={(e) => handleChange(e)}
                          isInvalid={touched.codigo && !!errors.codigo}
                        ></Form.Control>
                      </Col>
                      {loaderDepartamentUser ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                    {touched.codigo && errors.codigo && (
                      <Col>
                        <small className="text-danger">{errors.codigo}</small>
                      </Col>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Departamento
                    </Form.Label>
                    <Form.Control
                      name="nombre"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre}
                      placeholder="Departamento"
                      onBlur={handleBlur("nombre")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.nombre && !!errors.nombre}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre}
                    </Form.Control.Feedback>
                    {departamentUserFormError &&
                    typeof departamentUserFormError === "object" &&
                    departamentUserFormError.nombre ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {departamentUserFormError.nombre.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoaderDepartamentUser}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderDepartamentUser && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default DepartmentMaintenance;
